import { Dispatch, FC, SetStateAction } from 'react';
import { ModalActionBlock } from '.';
import { DataTagsForm } from '..';
import { DatasetCreationStepsEnum } from './types';

interface DataTagsStepProps {
  setActiveStep: Dispatch<SetStateAction<DatasetCreationStepsEnum>>;
}

const DataTagsStep: FC<DataTagsStepProps> = ({ setActiveStep }) => (
  <form>
    <DataTagsForm />
    <ModalActionBlock activeStep={DatasetCreationStepsEnum.DATA_TAGS} setActiveStep={setActiveStep} />
  </form>
);

export default DataTagsStep;
